import React from "react";
import _ from "lodash";
import {
  formatTimeWithoutSeconds,
  formatDateTimeWithoutSeconds,
} from "../../../../shared/dateTimeUtils";
import "./Pitocin.scss";

const PitocinDateTime = ({ expanded, time }) => {
  const datetime = expanded
    ? formatDateTimeWithoutSeconds(time)
    : formatTimeWithoutSeconds(time);
  return <div className="time">{datetime}</div>;
};

function Pitocin({ model, expanded }) {
  return (
    <div className="pitocin component">
      {_.orderBy(model.list, "time", "desc")
        .slice(0, 5)
        .map((dose) => (
          <div className="dose" key={dose.time}>
            <div className="wrapper">
              <PitocinDateTime expanded={expanded} time={dose.time} />
              <div className="amount">{dose.text}</div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default Pitocin;
